export var REQUEST_BRONZE_CHECK = 'REQUEST_BRONZE_CHECK';
export var SUCCESS_BRONZE_CHECK = 'SUCCESS_BRONZE_CHECK';
export var FAILURE_BRONZE_CHECK = 'FAILURE_BRONZE_CHECK';
export var REQUEST_BRONZE_ENTRY = 'REQUEST_BRONZE_ENTRY';
export var SUCCESS_BRONZE_ENTRY = 'SUCCESS_BRONZE_ENTRY';
export var FAILURE_BRONZE_ENTRY = 'FAILURE_BRONZE_ENTRY';
export var REQUEST_BRONZE_PAYMENT = 'REQUEST_BRONZE_PAYMENT';
export var SUCCESS_BRONZE_PAYMENT = 'SUCCESS_BRONZE_PAYMENT';
export var FAILURE_BRONZE_PAYMENT = 'FAILURE_BRONZE_PAYMENT';